export default {
  completePurchase: "COMPLETE YOUR PURCHASE",
  completePurchaseButton: "Complete Purchase",
  selectSitePrompt: "Please select a site before continuing."
};
